module.exports = __webpack_public_path__ + "assets/fox404_dark.png";